import React from 'react';
function ImageGallery({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect
        width="14"
        height="14"
        x="5"
        y="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx="2"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.888 11.222a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z"
        clipRule="evenodd"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 14.636L15.25 11 7 19M21.5 17h.5a1 1 0 001-1V8a1 1 0 00-1-1h-.5M2.5 7H2a1 1 0 00-1 1v8a1 1 0 001 1h.5"
      />
    </svg>
  );
}

export default ImageGallery;
